<template>
  <div>
    <el-row>
      <el-col :span="3">
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="5">
        <div class="block">
          <span class="demonstration"></span>
          <el-date-picker
            v-model="dateBetween"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
      </el-col>
      <el-col :span="6"
        ><el-button @click="analysis" type="primary">查询</el-button></el-col
      >
    </el-row>

    <el-row>
      <el-col :span="10">
        <div
          id="main"
          style="width: 100%; height: 400px; margin-top: 10px"
        ></div
      ></el-col>
      <el-col :span="10"
        ><div id="main1" style="width: 100%; height: 400px"></div
      ></el-col>
    </el-row>

    <el-row>
      <el-col :span="20">
        <div
          id="agent"
          style="width: 100%; height: 400px; margin-top: 10px"
        ></div
      ></el-col>
    </el-row>
  </div>
</template>
<style>
.el-table .warning-row {
  background: rgb(248, 239, 199);
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>

<script>
import NginxApi from "@/api/NginxApi";
export default {
  name: "NginxAnalysis",
  data() {
    return {
      options: [
        {
          value: "home.jybtech.cn",
          label: "首页",
        },
      ],
      value:"home.jybtech.cn",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      dateBetween: [],
      option: {},
    };
  },
  mounted() {
    this.analysis();
    this.categoryCount();
    this.agent();
  },
  methods: {
    agent() {
      NginxApi.agent().then((resp) => {
        if (resp.state == "OK") {
          let agent = []
          resp.data.forEach((item)=>{
              let name = item.agent.browser.name;
              let version = item.agent.version;
              agent.push({"name":name+"/"+version+"/"+item.agent.os.name,"value":item.num})
          })
          this.agentInit(agent);
        }
      });
    },
    categoryCount() {
      NginxApi.category().then((resp) => {
        if (resp.state == "OK") {
          let data = resp.data;
          this.ipData(data);
        }
      });
    },
    analysis() {
      let date = new Date();
      let defalutStartTime = date.getTime() - 7 * 24 * 3600 * 1000; // 转化为时间戳
      let startDateNs = new Date(defalutStartTime);
      this.dateBetween = [startDateNs, date];

      let start = this.dateBetween[0];
      let end = this.dateBetween[1];
      let category = this.value;
      NginxApi.flowData({ category, start, end }).then((resp) => {
        if (resp.state == "OK") {
          let xAxisData = resp.data.dateBetween;
          let serials = resp.data.dateItem;
          let legend = resp.data.legend;
          this.initFlowData(legend, xAxisData, serials);
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    initFlowData(legend, xAxisData, series) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.$echarts.init(document.getElementById("main"));
      var option;
      option = {
        title: {
          text: "经营帮频道访问量统计",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: legend,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {},
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xAxisData,
        },
        yAxis: {
          type: "value",
        },
        series: series,
      };
      this.option = option;
      option && myChart.setOption(option);
    },

    ipData(data) {
      var chartDom = document.getElementById("main1");
      var myChart = this.$echarts.init(chartDom);
      var option;
      option = {
        title: {
          text: "站点访问分布总量",
          subtext: "",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "78%",
        },
        series: [
          {
            name: "访问量",
            type: "pie",
            radius: "50%",
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },

    agentInit(data) {
      var chartDom = document.getElementById("agent");
      var myChart = this.$echarts.init(chartDom);
      var option;

      option = {
        title: {
          text: "浏览器分布总量",
          subtext: "",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "70%",
        },
        series: [
          {
            name: "浏览器分布",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "16",
              },
            },
            labelLine: {
              show: false,
            },
            data: data,
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>
